// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.listingcostandfee.FeeType

export enum FeeType {
  ACCESS_DEVICE = 'ACCESS_DEVICE',
  ACCESS_DEVICE_ADDITIONAL = 'ACCESS_DEVICE_ADDITIONAL',
  ACCESS_DEVICE_DEACTIVATION = 'ACCESS_DEVICE_DEACTIVATION',
  ACCESS_DEVICE_DEPOSIT = 'ACCESS_DEVICE_DEPOSIT',
  ACCESS_DEVICE_REPLACEMENT = 'ACCESS_DEVICE_REPLACEMENT',
  ACCESS_FEE_AFTER_HOURS = 'ACCESS_FEE_AFTER_HOURS',
  ACCESS_LOCK_CHANGE_FEE = 'ACCESS_LOCK_CHANGE_FEE',
  ADDITIONAL_OCCUPANT_FEE = 'ADDITIONAL_OCCUPANT_FEE',
  ADDITIONAL_PET_FEE = 'ADDITIONAL_PET_FEE',
  ADDITIONAL_SECURITY_DEPOSIT = 'ADDITIONAL_SECURITY_DEPOSIT',
  ADMINISTRATION_FEE = 'ADMINISTRATION_FEE',
  AIR_FILTER_DELIVERY_FEE = 'AIR_FILTER_DELIVERY_FEE',
  ALARM_SERVICES = 'ALARM_SERVICES',
  AMENITY_CLUBHOUSE_RENTAL = 'AMENITY_CLUBHOUSE_RENTAL',
  AMENITY_FEE = 'AMENITY_FEE',
  AMENITY_RENTAL = 'AMENITY_RENTAL',
  APPLIANCE_RELATED_CHARGE = 'APPLIANCE_RELATED_CHARGE',
  APPLIANCE_REPAIR = 'APPLIANCE_REPAIR',
  APPLICATION_DEPOSIT = 'APPLICATION_DEPOSIT',
  APPLICATION_FEE = 'APPLICATION_FEE',
  BIKE_STORAGE_FEE = 'BIKE_STORAGE_FEE',
  BIRD_DEPOSIT = 'BIRD_DEPOSIT',
  BIRD_FEE = 'BIRD_FEE',
  BIRD_RENT = 'BIRD_RENT',
  BOAT_SLIP = 'BOAT_SLIP',
  BOILER_MANAGEMENT = 'BOILER_MANAGEMENT',
  BROKER_FEE = 'BROKER_FEE',
  BUSINESS_OFFICE_RENTAL = 'BUSINESS_OFFICE_RENTAL',
  CABLE_FEE = 'CABLE_FEE',
  CABLE_FEE_UPGRADE = 'CABLE_FEE_UPGRADE',
  CABLE_TV_INTERNET_SERVICES = 'CABLE_TV_INTERNET_SERVICES',
  CARPORT_PARKING_FEE = 'CARPORT_PARKING_FEE',
  CAR_SERVICES = 'CAR_SERVICES',
  CAR_WASH = 'CAR_WASH',
  CAT_DEPOSIT = 'CAT_DEPOSIT',
  CAT_FEE = 'CAT_FEE',
  CAT_RENT = 'CAT_RENT',
  CA_TRASH_SERVICES_FEE = 'CA_TRASH_SERVICES_FEE',
  CEILING_FAN = 'CEILING_FAN',
  CHILLED_WATER_FEE = 'CHILLED_WATER_FEE',
  CLEANING_FEE = 'CLEANING_FEE',
  COMMON_AREA_ELECTRIC = 'COMMON_AREA_ELECTRIC',
  COMMON_AREA_GAS = 'COMMON_AREA_GAS',
  COMMON_AREA_MAINTENANCE = 'COMMON_AREA_MAINTENANCE',
  COMMON_AREA_WATER_SEWER = 'COMMON_AREA_WATER_SEWER',
  COMMUNITY_FEE = 'COMMUNITY_FEE',
  CONCESSION_REPAYMENT = 'CONCESSION_REPAYMENT',
  CONCIERGE_SERVICES = 'CONCIERGE_SERVICES',
  COVERED_PARKING_FEE = 'COVERED_PARKING_FEE',
  CREDIT_CHECK_FEE = 'CREDIT_CHECK_FEE',
  CREDIT_REPORTING_SERVICES = 'CREDIT_REPORTING_SERVICES',
  CUSTOM_FEE = 'CUSTOM_FEE',
  DAMAGE_FEE = 'DAMAGE_FEE',
  DAMAGE_WAIVER_FEE = 'DAMAGE_WAIVER_FEE',
  DOG_DEPOSIT = 'DOG_DEPOSIT',
  DOG_FEE = 'DOG_FEE',
  DOG_RENT = 'DOG_RENT',
  DOORSTEP_TRASH_SERVICES = 'DOORSTEP_TRASH_SERVICES',
  DRAINAGE_FEE = 'DRAINAGE_FEE',
  EARLY_MOVE_IN_FEE = 'EARLY_MOVE_IN_FEE',
  EARLY_TERMINATION_FEE = 'EARLY_TERMINATION_FEE',
  ELECTRICITY_FEE = 'ELECTRICITY_FEE',
  ELECTRICITY_FEE_THIRD_PARTY = 'ELECTRICITY_FEE_THIRD_PARTY',
  ENVIRONMENTAL_FEE = 'ENVIRONMENTAL_FEE',
  EVENT_ACTIVITY_RESERVATION = 'EVENT_ACTIVITY_RESERVATION',
  EV_CHARGING_FEE = 'EV_CHARGING_FEE',
  EV_PARKING_FEE = 'EV_PARKING_FEE',
  EXPRESS_MOVE_OUT = 'EXPRESS_MOVE_OUT',
  EXTERMINATION_SERVICES_VIOLATION = 'EXTERMINATION_SERVICES_VIOLATION',
  FENCE_FEE = 'FENCE_FEE',
  FISH_DEPOSIT = 'FISH_DEPOSIT',
  FISH_FEE = 'FISH_FEE',
  FISH_RENT = 'FISH_RENT',
  FOOD_SERVICES = 'FOOD_SERVICES',
  FURNITURE_RENTAL = 'FURNITURE_RENTAL',
  GARAGE_PARKING_FEE = 'GARAGE_PARKING_FEE',
  GARBAGE_ADMIN_FEE = 'GARBAGE_ADMIN_FEE',
  GARBAGE_FEE = 'GARBAGE_FEE',
  GAS_ADMIN_FEE = 'GAS_ADMIN_FEE',
  GAS_FEE = 'GAS_FEE',
  GUEST_PARKING_FEE = 'GUEST_PARKING_FEE',
  GUEST_SERVICES = 'GUEST_SERVICES',
  GUEST_SUITE_RENTAL = 'GUEST_SUITE_RENTAL',
  GYM_FEE = 'GYM_FEE',
  HEATING_FEE = 'HEATING_FEE',
  HOA_AMENITY_FEE = 'HOA_AMENITY_FEE',
  HOA_APPLICATION_FEE = 'HOA_APPLICATION_FEE',
  HOA_FEE = 'HOA_FEE',
  HOLDING_DEPOSIT = 'HOLDING_DEPOSIT',
  HOLDING_FEE = 'HOLDING_FEE',
  HOT_WATER_ENERGY = 'HOT_WATER_ENERGY',
  HOURLY_PARKING_FEE = 'HOURLY_PARKING_FEE',
  INSUFFICIENT_FUNDS_FEE = 'INSUFFICIENT_FUNDS_FEE',
  INTERNET_FEE = 'INTERNET_FEE',
  LANDSCAPING_FEE = 'LANDSCAPING_FEE',
  LAST_MONTH_S_RENT = 'LAST_MONTH_S_RENT',
  LATE_FEE = 'LATE_FEE',
  LATE_MOVE_OUT_FEE = 'LATE_MOVE_OUT_FEE',
  LAUNDRY_SERVICE_FEE = 'LAUNDRY_SERVICE_FEE',
  LAWN_MAINTENANCE_FEE = 'LAWN_MAINTENANCE_FEE',
  LEASE_BUY_OUT = 'LEASE_BUY_OUT',
  LEASE_PROCESSING_FEE = 'LEASE_PROCESSING_FEE',
  LEASE_VIOLATION = 'LEASE_VIOLATION',
  LEASE_VIOLATION_PET = 'LEASE_VIOLATION_PET',
  LEASE_VIOLATION_SMOKING = 'LEASE_VIOLATION_SMOKING',
  LEASE_VIOLATION_VEHICLE = 'LEASE_VIOLATION_VEHICLE',
  LEGAL_EVICTION_FEES = 'LEGAL_EVICTION_FEES',
  LIFESTYLE_FEE = 'LIFESTYLE_FEE',
  LIGHTING_SUPPLIES_REPAIRS = 'LIGHTING_SUPPLIES_REPAIRS',
  LIGHT_REPLACEMENT_FEE = 'LIGHT_REPLACEMENT_FEE',
  LIQUIDATED_DAMAGES = 'LIQUIDATED_DAMAGES',
  MEDIA_PACKAGE = 'MEDIA_PACKAGE',
  MONTH_TO_MONTH_FEE = 'MONTH_TO_MONTH_FEE',
  MUNICIPALITY_FEE = 'MUNICIPALITY_FEE',
  NATURAL_GAS_FEE_THIRD_PARTY = 'NATURAL_GAS_FEE_THIRD_PARTY',
  NONCOMPLIANCE_FEE = 'NONCOMPLIANCE_FEE',
  NON_REFUNDABLE_PET_FEE = 'NON_REFUNDABLE_PET_FEE',
  PACKAGE_DELIVERY_FEE = 'PACKAGE_DELIVERY_FEE',
  PACKAGE_LOCKER_FEE = 'PACKAGE_LOCKER_FEE',
  PACKAGE_SERVICES_REGISTRATION = 'PACKAGE_SERVICES_REGISTRATION',
  PACKAGE_SERVICES_VIOLATION = 'PACKAGE_SERVICES_VIOLATION',
  PARKING_FEE = 'PARKING_FEE',
  PARKING_FEE_THIRD_PARTY = 'PARKING_FEE_THIRD_PARTY',
  PARKING_LOT_MAINTENANCE_FEE = 'PARKING_LOT_MAINTENANCE_FEE',
  PARKING_PERMIT = 'PARKING_PERMIT',
  PAYMENT_SERVICES_FEE = 'PAYMENT_SERVICES_FEE',
  PEST_CONTROL_FEE = 'PEST_CONTROL_FEE',
  PET_AMENITY_SERVICES = 'PET_AMENITY_SERVICES',
  PET_DEPOSIT = 'PET_DEPOSIT',
  PET_FEE = 'PET_FEE',
  PET_ID_REPLACEMENT_FEE = 'PET_ID_REPLACEMENT_FEE',
  PET_MANAGEMENT_FEE = 'PET_MANAGEMENT_FEE',
  PET_RENT = 'PET_RENT',
  PET_RENT_ADDITIONAL_PET = 'PET_RENT_ADDITIONAL_PET',
  PET_SCREENING_FEE = 'PET_SCREENING_FEE',
  PET_VIOLATION_FEE = 'PET_VIOLATION_FEE',
  PET_WASTE_VIOLATION_FEE = 'PET_WASTE_VIOLATION_FEE',
  POOL_MAINTENANCE_FEE = 'POOL_MAINTENANCE_FEE',
  PROGRAM_SURCHARGE_421A = 'PROGRAM_SURCHARGE_421A',
  REAL_ESTATE_ASSESSMENT_FEE = 'REAL_ESTATE_ASSESSMENT_FEE',
  RECYCLING_TRASH_SERVICES = 'RECYCLING_TRASH_SERVICES',
  RELETTING_FEE = 'RELETTING_FEE',
  REMOTE_DEPOSIT = 'REMOTE_DEPOSIT',
  RENTAL_HOME_UPGRADE = 'RENTAL_HOME_UPGRADE',
  RENTERS_INSURANCE_COMPLIANCE_FEE = 'RENTERS_INSURANCE_COMPLIANCE_FEE',
  RENTERS_INSURANCE_FEE = 'RENTERS_INSURANCE_FEE',
  RENTERS_INSURANCE_FEE_THIRD_PARTY = 'RENTERS_INSURANCE_FEE_THIRD_PARTY',
  RENTERS_INSURANCE_PROGRAM_VALIDATION_FEE = 'RENTERS_INSURANCE_PROGRAM_VALIDATION_FEE',
  RENT_BOARD_FEE = 'RENT_BOARD_FEE',
  RENT_SERVICE_FEE = 'RENT_SERVICE_FEE',
  REPTILE_DEPOSIT = 'REPTILE_DEPOSIT',
  REPTILE_FEE = 'REPTILE_FEE',
  REPTILE_RENT = 'REPTILE_RENT',
  RESERVED_PARKING_FEE = 'RESERVED_PARKING_FEE',
  RESIDENT_CHANGE_FEE = 'RESIDENT_CHANGE_FEE',
  RESIDENT_SERVICES_FEE = 'RESIDENT_SERVICES_FEE',
  RISK_PREMIUM_DEPOSIT = 'RISK_PREMIUM_DEPOSIT',
  SATELLITE_DISH_DEPOSIT = 'SATELLITE_DISH_DEPOSIT',
  SCEP_FEE = 'SCEP_FEE',
  SECURITY_DEPOSIT = 'SECURITY_DEPOSIT',
  SECURITY_DEPOSIT_ALTERNATIVE = 'SECURITY_DEPOSIT_ALTERNATIVE',
  SEPTIC_FEE = 'SEPTIC_FEE',
  SEWER_FEE = 'SEWER_FEE',
  SEWER_FEE_THIRD_PARTY = 'SEWER_FEE_THIRD_PARTY',
  SHORT_TERM_FEE = 'SHORT_TERM_FEE',
  SMART_FEE = 'SMART_FEE',
  SMART_HOME_FEE = 'SMART_HOME_FEE',
  SMART_LOCK_FEE = 'SMART_LOCK_FEE',
  SOLAR_HOME_FEE = 'SOLAR_HOME_FEE',
  STORAGE_FEE = 'STORAGE_FEE',
  STORAGE_LOCKER_FEE = 'STORAGE_LOCKER_FEE',
  STORMWATER_FEE = 'STORMWATER_FEE',
  SURFACE_LOT_PARKING_FEE = 'SURFACE_LOT_PARKING_FEE',
  TANDEM_PARKING_FEE = 'TANDEM_PARKING_FEE',
  TECHNOLOGY_FEE = 'TECHNOLOGY_FEE',
  TELEPHONE_SERVICES = 'TELEPHONE_SERVICES',
  TENANT_DEPOSIT = 'TENANT_DEPOSIT',
  TRANSFER_FEE = 'TRANSFER_FEE',
  TRASH_CONTAINER_REPLACEMENT_FEE = 'TRASH_CONTAINER_REPLACEMENT_FEE',
  TRASH_RELATED_LEASE_VIOLATION = 'TRASH_RELATED_LEASE_VIOLATION',
  UNCLASSIFIED = 'UNCLASSIFIED',
  UTILITIES_ADMIN_FEE = 'UTILITIES_ADMIN_FEE',
  UTILITIES_CLOSE_ACCOUNT_FEE = 'UTILITIES_CLOSE_ACCOUNT_FEE',
  UTILITIES_MONTHLY_FEE = 'UTILITIES_MONTHLY_FEE',
  UTILITIES_SET_UP_FEE = 'UTILITIES_SET_UP_FEE',
  UTILITY_BILLING_BUNDLE = 'UTILITY_BILLING_BUNDLE',
  UTILITY_VACANT_COST_RECOVERY = 'UTILITY_VACANT_COST_RECOVERY',
  UTILITY_VACANT_PROCESSING_FEE = 'UTILITY_VACANT_PROCESSING_FEE',
  VALET_TRASH_FEE = 'VALET_TRASH_FEE',
  VARIABLE_REFRIGERANT_FLOW_FEE = 'VARIABLE_REFRIGERANT_FLOW_FEE',
  VEHICLE_REGISTRATION_FEE = 'VEHICLE_REGISTRATION_FEE',
  WAIT_LIST_DEPOSIT = 'WAIT_LIST_DEPOSIT',
  WASHER_DRYER_RENTAL = 'WASHER_DRYER_RENTAL',
  WATER_FEE = 'WATER_FEE',
  WATER_FEE_THIRD_PARTY = 'WATER_FEE_THIRD_PARTY',
  WATER_SEWER_FEE = 'WATER_SEWER_FEE',
  WATER_SEWER_FEE_THIRD_PARTY = 'WATER_SEWER_FEE_THIRD_PARTY',
  WATER_SEWER_GARBAGE_FEE = 'WATER_SEWER_GARBAGE_FEE',
  WIRE_TRANSFER_FEE = 'WIRE_TRANSFER_FEE',
  YARD_MAINTENANCE_FEE = 'YARD_MAINTENANCE_FEE',
}

export const FeeType_values = [
  FeeType.ACCESS_DEVICE,
  FeeType.ACCESS_DEVICE_ADDITIONAL,
  FeeType.ACCESS_DEVICE_DEACTIVATION,
  FeeType.ACCESS_DEVICE_DEPOSIT,
  FeeType.ACCESS_DEVICE_REPLACEMENT,
  FeeType.ACCESS_FEE_AFTER_HOURS,
  FeeType.ACCESS_LOCK_CHANGE_FEE,
  FeeType.ADDITIONAL_OCCUPANT_FEE,
  FeeType.ADDITIONAL_PET_FEE,
  FeeType.ADDITIONAL_SECURITY_DEPOSIT,
  FeeType.ADMINISTRATION_FEE,
  FeeType.AIR_FILTER_DELIVERY_FEE,
  FeeType.ALARM_SERVICES,
  FeeType.AMENITY_CLUBHOUSE_RENTAL,
  FeeType.AMENITY_FEE,
  FeeType.AMENITY_RENTAL,
  FeeType.APPLIANCE_RELATED_CHARGE,
  FeeType.APPLIANCE_REPAIR,
  FeeType.APPLICATION_DEPOSIT,
  FeeType.APPLICATION_FEE,
  FeeType.BIKE_STORAGE_FEE,
  FeeType.BIRD_DEPOSIT,
  FeeType.BIRD_FEE,
  FeeType.BIRD_RENT,
  FeeType.BOAT_SLIP,
  FeeType.BOILER_MANAGEMENT,
  FeeType.BROKER_FEE,
  FeeType.BUSINESS_OFFICE_RENTAL,
  FeeType.CABLE_FEE,
  FeeType.CABLE_FEE_UPGRADE,
  FeeType.CABLE_TV_INTERNET_SERVICES,
  FeeType.CARPORT_PARKING_FEE,
  FeeType.CAR_SERVICES,
  FeeType.CAR_WASH,
  FeeType.CAT_DEPOSIT,
  FeeType.CAT_FEE,
  FeeType.CAT_RENT,
  FeeType.CA_TRASH_SERVICES_FEE,
  FeeType.CEILING_FAN,
  FeeType.CHILLED_WATER_FEE,
  FeeType.CLEANING_FEE,
  FeeType.COMMON_AREA_ELECTRIC,
  FeeType.COMMON_AREA_GAS,
  FeeType.COMMON_AREA_MAINTENANCE,
  FeeType.COMMON_AREA_WATER_SEWER,
  FeeType.COMMUNITY_FEE,
  FeeType.CONCESSION_REPAYMENT,
  FeeType.CONCIERGE_SERVICES,
  FeeType.COVERED_PARKING_FEE,
  FeeType.CREDIT_CHECK_FEE,
  FeeType.CREDIT_REPORTING_SERVICES,
  FeeType.CUSTOM_FEE,
  FeeType.DAMAGE_FEE,
  FeeType.DAMAGE_WAIVER_FEE,
  FeeType.DOG_DEPOSIT,
  FeeType.DOG_FEE,
  FeeType.DOG_RENT,
  FeeType.DOORSTEP_TRASH_SERVICES,
  FeeType.DRAINAGE_FEE,
  FeeType.EARLY_MOVE_IN_FEE,
  FeeType.EARLY_TERMINATION_FEE,
  FeeType.ELECTRICITY_FEE,
  FeeType.ELECTRICITY_FEE_THIRD_PARTY,
  FeeType.ENVIRONMENTAL_FEE,
  FeeType.EVENT_ACTIVITY_RESERVATION,
  FeeType.EV_CHARGING_FEE,
  FeeType.EV_PARKING_FEE,
  FeeType.EXPRESS_MOVE_OUT,
  FeeType.EXTERMINATION_SERVICES_VIOLATION,
  FeeType.FENCE_FEE,
  FeeType.FISH_DEPOSIT,
  FeeType.FISH_FEE,
  FeeType.FISH_RENT,
  FeeType.FOOD_SERVICES,
  FeeType.FURNITURE_RENTAL,
  FeeType.GARAGE_PARKING_FEE,
  FeeType.GARBAGE_ADMIN_FEE,
  FeeType.GARBAGE_FEE,
  FeeType.GAS_ADMIN_FEE,
  FeeType.GAS_FEE,
  FeeType.GUEST_PARKING_FEE,
  FeeType.GUEST_SERVICES,
  FeeType.GUEST_SUITE_RENTAL,
  FeeType.GYM_FEE,
  FeeType.HEATING_FEE,
  FeeType.HOA_AMENITY_FEE,
  FeeType.HOA_APPLICATION_FEE,
  FeeType.HOA_FEE,
  FeeType.HOLDING_DEPOSIT,
  FeeType.HOLDING_FEE,
  FeeType.HOT_WATER_ENERGY,
  FeeType.HOURLY_PARKING_FEE,
  FeeType.INSUFFICIENT_FUNDS_FEE,
  FeeType.INTERNET_FEE,
  FeeType.LANDSCAPING_FEE,
  FeeType.LAST_MONTH_S_RENT,
  FeeType.LATE_FEE,
  FeeType.LATE_MOVE_OUT_FEE,
  FeeType.LAUNDRY_SERVICE_FEE,
  FeeType.LAWN_MAINTENANCE_FEE,
  FeeType.LEASE_BUY_OUT,
  FeeType.LEASE_PROCESSING_FEE,
  FeeType.LEASE_VIOLATION,
  FeeType.LEASE_VIOLATION_PET,
  FeeType.LEASE_VIOLATION_SMOKING,
  FeeType.LEASE_VIOLATION_VEHICLE,
  FeeType.LEGAL_EVICTION_FEES,
  FeeType.LIFESTYLE_FEE,
  FeeType.LIGHTING_SUPPLIES_REPAIRS,
  FeeType.LIGHT_REPLACEMENT_FEE,
  FeeType.LIQUIDATED_DAMAGES,
  FeeType.MEDIA_PACKAGE,
  FeeType.MONTH_TO_MONTH_FEE,
  FeeType.MUNICIPALITY_FEE,
  FeeType.NATURAL_GAS_FEE_THIRD_PARTY,
  FeeType.NONCOMPLIANCE_FEE,
  FeeType.NON_REFUNDABLE_PET_FEE,
  FeeType.PACKAGE_DELIVERY_FEE,
  FeeType.PACKAGE_LOCKER_FEE,
  FeeType.PACKAGE_SERVICES_REGISTRATION,
  FeeType.PACKAGE_SERVICES_VIOLATION,
  FeeType.PARKING_FEE,
  FeeType.PARKING_FEE_THIRD_PARTY,
  FeeType.PARKING_LOT_MAINTENANCE_FEE,
  FeeType.PARKING_PERMIT,
  FeeType.PAYMENT_SERVICES_FEE,
  FeeType.PEST_CONTROL_FEE,
  FeeType.PET_AMENITY_SERVICES,
  FeeType.PET_DEPOSIT,
  FeeType.PET_FEE,
  FeeType.PET_ID_REPLACEMENT_FEE,
  FeeType.PET_MANAGEMENT_FEE,
  FeeType.PET_RENT,
  FeeType.PET_RENT_ADDITIONAL_PET,
  FeeType.PET_SCREENING_FEE,
  FeeType.PET_VIOLATION_FEE,
  FeeType.PET_WASTE_VIOLATION_FEE,
  FeeType.POOL_MAINTENANCE_FEE,
  FeeType.PROGRAM_SURCHARGE_421A,
  FeeType.REAL_ESTATE_ASSESSMENT_FEE,
  FeeType.RECYCLING_TRASH_SERVICES,
  FeeType.RELETTING_FEE,
  FeeType.REMOTE_DEPOSIT,
  FeeType.RENTAL_HOME_UPGRADE,
  FeeType.RENTERS_INSURANCE_COMPLIANCE_FEE,
  FeeType.RENTERS_INSURANCE_FEE,
  FeeType.RENTERS_INSURANCE_FEE_THIRD_PARTY,
  FeeType.RENTERS_INSURANCE_PROGRAM_VALIDATION_FEE,
  FeeType.RENT_BOARD_FEE,
  FeeType.RENT_SERVICE_FEE,
  FeeType.REPTILE_DEPOSIT,
  FeeType.REPTILE_FEE,
  FeeType.REPTILE_RENT,
  FeeType.RESERVED_PARKING_FEE,
  FeeType.RESIDENT_CHANGE_FEE,
  FeeType.RESIDENT_SERVICES_FEE,
  FeeType.RISK_PREMIUM_DEPOSIT,
  FeeType.SATELLITE_DISH_DEPOSIT,
  FeeType.SCEP_FEE,
  FeeType.SECURITY_DEPOSIT,
  FeeType.SECURITY_DEPOSIT_ALTERNATIVE,
  FeeType.SEPTIC_FEE,
  FeeType.SEWER_FEE,
  FeeType.SEWER_FEE_THIRD_PARTY,
  FeeType.SHORT_TERM_FEE,
  FeeType.SMART_FEE,
  FeeType.SMART_HOME_FEE,
  FeeType.SMART_LOCK_FEE,
  FeeType.SOLAR_HOME_FEE,
  FeeType.STORAGE_FEE,
  FeeType.STORAGE_LOCKER_FEE,
  FeeType.STORMWATER_FEE,
  FeeType.SURFACE_LOT_PARKING_FEE,
  FeeType.TANDEM_PARKING_FEE,
  FeeType.TECHNOLOGY_FEE,
  FeeType.TELEPHONE_SERVICES,
  FeeType.TENANT_DEPOSIT,
  FeeType.TRANSFER_FEE,
  FeeType.TRASH_CONTAINER_REPLACEMENT_FEE,
  FeeType.TRASH_RELATED_LEASE_VIOLATION,
  FeeType.UNCLASSIFIED,
  FeeType.UTILITIES_ADMIN_FEE,
  FeeType.UTILITIES_CLOSE_ACCOUNT_FEE,
  FeeType.UTILITIES_MONTHLY_FEE,
  FeeType.UTILITIES_SET_UP_FEE,
  FeeType.UTILITY_BILLING_BUNDLE,
  FeeType.UTILITY_VACANT_COST_RECOVERY,
  FeeType.UTILITY_VACANT_PROCESSING_FEE,
  FeeType.VALET_TRASH_FEE,
  FeeType.VARIABLE_REFRIGERANT_FLOW_FEE,
  FeeType.VEHICLE_REGISTRATION_FEE,
  FeeType.WAIT_LIST_DEPOSIT,
  FeeType.WASHER_DRYER_RENTAL,
  FeeType.WATER_FEE,
  FeeType.WATER_FEE_THIRD_PARTY,
  FeeType.WATER_SEWER_FEE,
  FeeType.WATER_SEWER_FEE_THIRD_PARTY,
  FeeType.WATER_SEWER_GARBAGE_FEE,
  FeeType.WIRE_TRANSFER_FEE,
  FeeType.YARD_MAINTENANCE_FEE,
] as const;
